import { useQuery } from '@tanstack/react-query';
import type { OrgEntitlements } from '@jeket-cloud/types';
import { getOrgOverride, meApi } from '@/api/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * The acting org's surface entitlements (#1160), from `GET
 * /api/me/entitlements`, read once per acting org (switching org reloads the
 * page, and the key carries the org too).
 *
 * `entitlements` is undefined while loading and on error. Callers treat
 * that as "every surface on": the default is all-on, and the BFF refuses a
 * disabled surface's API whatever the SPA shows, so a failed read never
 * hides a surface the org has. (Unlike useFeature, whose default is off.)
 */
export function useEntitlements(): { entitlements: OrgEntitlements | undefined; isLoading: boolean } {
  const { user } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ['entitlements', getOrgOverride()],
    queryFn: () => meApi.entitlements(),
    enabled: !!user,
    staleTime: 60_000,
  });
  return { entitlements: data, isLoading: !!user && isLoading };
}
